<template>
    <div class="view-menu-user-container">
        <el-dialog :title="$t('menuUserManage.list.title')" :visible.sync="dialogVisible" width="72%"
            :before-close="handleClose" custom-class="view-menu-user-dialog">
            <div v-loading="loading" class="common-menu-content">
            <el-row class="menu-items" :gutter="16">
                <el-col v-for="(item, index) in viewMenuUserInfo.menus" :key="index" :span="4"
                    class="text-center menu-item" role="button" tabindex="0" @click.native="jumpToUserPage(item)"
                    @keyup.enter.native="jumpToUserPage(item)">
                    <div class="menu-item-card">
                        <i :class="item.icon" class="menu-icon"></i>
                        <div class="menu-name">
                            {{ item.name }}
                        </div>
                    </div>
                </el-col>
                <el-col :span="4" class="text-center menu-item add-menu-item" role="button" tabindex="0"
                    @click.native="toUserMenu" @keyup.enter.native="toUserMenu">
                    <div class="menu-item-card">
                        <i class="el-icon-plus menu-icon"></i>
                        <div class="menu-name">
                            {{ $t('common.add') }}
                        </div>
                    </div>
                </el-col>
            </el-row>
            <div v-if="!loading && viewMenuUserInfo.menus.length === 0" class="empty-menu-hint">
                暂无常用菜单，可点击“{{ $t('common.add') }}”进行配置
            </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { listMenuUser } from '@/api/system/viewMenuUserApi'

export default {
    name: 'ViewMenuUserList',
    data() {
        return {
            dialogVisible: false,
            loading: false,
            viewMenuUserInfo: {
                menus: []
            }
        }
    },
    methods: {
        open() {
            this.dialogVisible = true
            this.listViewMenuUsers()
        },
        handleClose() {
            this.dialogVisible = false
        },
        async listViewMenuUsers() {
            this.loading = true
            try {
                const params = {
                    page: 1,
                    row: 100
                }
                const { data } = await listMenuUser(params)
                this.viewMenuUserInfo.menus = Array.isArray(data) ? data : []
            } catch (error) {
                this.viewMenuUserInfo.menus = []
                console.error('获取常用菜单失败：', error)
                this.$message.error(this.$t('menuUserManage.fetchError'))
            } finally {
                this.loading = false
            }
        },
        toUserMenu() {
            this.handleClose()
            this.$router.push('/views/system/menuUserManage?tab=commonMenu')
        },
        jumpToUserPage(item) {
            this.handleClose()
            let href = item.url
            if (href.indexOf('/#/') > -1) {
                href = href.replace('/#/', '/')
            }
            if (href.indexOf('?') > -1) {
                href += `&tab=${item.name}`
            } else {
                href += `?tab=${item.name}`
            }
            this.$router.push(href)
        }
    }
}
</script>

<style lang="scss" scoped>
.view-menu-user-container {
    ::v-deep .view-menu-user-dialog {
        max-width: 960px;

        .el-dialog__header {
            display: block;
        }

        .el-dialog__body {
            min-height: 220px;
            padding: 24px;
            color: var(--hc-text-regular);
            background: #fff;
        }
    }

    .common-menu-content {
        min-height: 172px;
    }

    .menu-items {
        margin-top: 0;
    }

    .menu-item {
        margin-bottom: 16px;
        outline: none;

        .menu-item-card {
            box-sizing: border-box;
            min-height: 116px;
            padding: 22px 10px 16px;
            cursor: pointer;
            border: 1px solid var(--hc-border);
            border-radius: 10px;
            background: #fff;
            transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
        }

        &:hover .menu-item-card,
        &:focus .menu-item-card {
            border-color: #93c5fd;
            background: #eff6ff;
            box-shadow: 0 8px 20px rgba(37, 99, 235, 0.12);
            transform: translateY(-2px);
        }

        &:hover .menu-icon,
        &:hover .menu-name,
        &:focus .menu-icon,
        &:focus .menu-name {
            color: var(--hc-primary);
        }
    }

    .menu-icon {
        display: block;
        margin-bottom: 12px;
        color: #64748b;
        font-size: 34px;
        line-height: 38px;
        transition: color 0.2s ease;
    }

    .menu-name {
        overflow: hidden;
        color: var(--hc-text-primary);
        font-size: 14px;
        font-weight: 500;
        line-height: 20px;
        text-overflow: ellipsis;
        white-space: nowrap;
        transition: color 0.2s ease;
    }

    .add-menu-item .menu-item-card {
        border-style: dashed;
        background: #f8fafc;
    }

    .add-menu-item .menu-icon {
        color: var(--hc-primary);
    }

    .empty-menu-hint {
        margin-top: 8px;
        color: var(--hc-text-secondary);
        font-size: 13px;
        line-height: 20px;
        text-align: center;
    }
}
</style>
